import {
  Button,
  Collapse,
  Empty,
  Input,
  Popconfirm,
  Select,
  Space,
  Spin,
  Table,
  Tag,
  Typography
} from "antd";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { AppDispatch, RootState } from "../../../../app/store";
import { useDispatch, useSelector } from "react-redux";
import { getQuestionsDatas } from "./slice";
import questionsAdmin from "../../../../apis/admin/question";
import notificationHandler from "../../../atoms/Notification";
import {
  DeleteOutlined,
  FormOutlined,
  LoadingOutlined,
  PlusCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import "./question.scss";

const ListQuestion = () => {
  const { questions }: any = useSelector(
    (state: RootState) => state.questionsList
  );
  const dispatch = useDispatch<AppDispatch>();
  const { Panel } = Collapse;
  const { Search } = Input;
  const [status, setStatus] = React.useState<any>("");
  const [type, setType] = React.useState<any>("");
  const [content, setContent] = React.useState<any>("");
  const [loading, setLoading] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);

  const handlePageChange = (page: any) => {
    setCurrentPage(page);
  };

  const [pageSize, setPageSize] = React.useState(10);

  const displayedIndex = (index: any) =>
    (currentPage - 1) * pageSize + index + 1;
  const customButton = (
    <Button className="border-none mr-3" icon={<SearchOutlined />} />
  );

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 70, position: "fixed" }} spin />
  );

  const { Title } = Typography;

  useEffect(() => {
    setLoading(true)
    dispatch(
      getQuestionsDatas({ content: content, status: status, type: type })
    ).then().catch().finally(() =>setLoading(false));
  }, [dispatch]);

  const confirm = (id: number) => {
    setLoading(true);
    questionsAdmin
      .removeQuestions(id)
      .then(() => {
        dispatch(
          getQuestionsDatas({ content: content, status: status, type: type })
        );
        notificationHandler("success", "Xóa câu hỏi thành công!");
        setLoading(false);
      })
      .catch((err) => {
        notificationHandler("error", err.response.data.data.msg_content);
        setLoading(false);
      });
  };
  const onSearch = (value: string) => {
    if (value == undefined) value = ""
    setContent(value);
    dispatch(getQuestionsDatas({ content: value, status: status, type: type }))
      .unwrap()
      .then((item) => {
        setCurrentPage(1);
      });
  };
  const handleSearchStatus = (value: string) => {
    if (value == undefined) value = ""
    setStatus(value);
    dispatch(getQuestionsDatas({ content: content, status: value, type: type }))
      .unwrap()
      .then((item) => {
        setCurrentPage(1);
      });
  };
  const handleSearchType = (value: string) => {
    if (value == undefined) value = ""
    setType(value);
    dispatch(
      getQuestionsDatas({ content: content, status: status, type: value })
    )
      .unwrap()
      .then((item) => {
        setCurrentPage(1);
      });
  };

  const columns: any = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      align: "center",
      width: "5%",
      render: (_: any, __: any, index: any) => displayedIndex(index),
    },
    {
      title: "Câu hỏi",
      dataIndex: "title",
      key: "title",
      render: (text: string, record: any) => {
        return (
          <Collapse>
            <Panel header={record.content} key={1}>
              {record.type == 1 ? (
                <div className="flex flex-col">
                  Đáp án:
                  {record.options.map((item: any, key: number) => (
                    <span key={key}>
                      {key + 1}: {item.value}
                    </span>
                  ))}
                </div>
              ) : (
                "Không có dữ liệu"
              )}
            </Panel>
          </Collapse>
        );
      },
    },
    {
      title: "Vị trí",
      key: "questionOrder",
      dataIndex: "questionOrder",
      align: "center",
      width: "5%",
    },
    {
      title: "Loại câu hỏi",
      key: "type",
      dataIndex: "type",
      align: "center",
      width: "8%",
      render: (type: any, record: any, index: number) => {
        let color = "blue";
        return (
          <div>
            {type == 0 && (
              <Tag color={color} key={type} className="py-1">
                Tự luận
              </Tag>
            )}
            {type == 1 && (
              <Tag color={color} key={type} className="py-1">
                Trắc nghiệm
              </Tag>
            )}
            {type == null && ""}
          </div>
        );
      },
    },
    {
      title: "Trạng thái",
      key: "status",
      dataIndex: "status",
      align: "center",
      width: "5%",
      render: (status: number, record: any, index: number) => {
        let color = "green";
        let color1 = "volcano";
        let text1 = "Hoạt động";
        let text = "Không hoạt động";
        return (
          <div>
            {status === 1 && (
              <Tag color={color} key={status} className="py-1">
                {text1}
              </Tag>
            )}
            {status === 0 && (
              <Tag color={color1} key={status} className="py-1">
                {text}
              </Tag>
            )}
            {status === 0 && ""}
          </div>
        );
      },
    },
    {
      title: "Hành động",
      dataIndex: "id",
      width: "5%",
      align: "center",
      render: (text: string, record: any) => {
        return (
          <Space size="small">
            <Button className="mr-1 hover:border-[#FAAD14] hover:text-[#FAAD14] bg-[#FAAD14] border-[#FAAD14] p-[5px_10px] text-white ">
              <Link
                to={`/admin/editQuestion/${record.id}`}
                className="flex items-center"
              >
                <FormOutlined className="mr-1" /> Sửa
              </Link>
            </Button>
            <Popconfirm
              title="Bạn có muốn xóa câu hỏi này không?"
              onConfirm={() => confirm(record.id)}
              okText="Xóa"
              cancelText="Hủy"
              okType="danger"
            >
              <Button
                danger
                className="bg-[#ff4d4f] text-white "
                loading={loading}
              >
                <div className="flex items-center">
                  <DeleteOutlined className="pr-1" />
                  Xóa
                </div>
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  return (
    <div id="question">
      <Spin indicator={antIcon} spinning={loading} />
      <div className="flex justify-between">
        <div className="w-[70%]">
          <div className="flex header-select">
          <Input
              placeholder="Tìm kiếm câu hỏi"
              maxLength={200}
              onChange={(e) => onSearch(e.target.value)}
              prefix={<SearchOutlined />}
              className="w-[35%]"
              allowClear
              onBlur={(e) => setContent(e.target.value.trim())}
              value={content}
            />
            <Select
              style={{ width: "15%" }}
              className="ml-3"
              onChange={handleSearchType}
              placeholder={"Chọn loại câu hỏi"}
              allowClear
              options={[
                // { value: "", label: "Chọn loại câu hỏi" },
                { value: 1, label: "Trắc nghiệm" },
                { value: 0, label: "Tự luận" },
              ]}
            />
            <Select
              style={{ width: "15%" }}
              className="ml-3"
              onChange={handleSearchStatus}
              placeholder={"Chọn trạng thái"}
              allowClear
              options={[
                // { value: "", label: "Chọn trạng thái" },
                { value: 0, label: "Không hoạt động" },
                { value: 1, label: "Hoạt động" },
              ]}
            />
          </div>
        </div>
        <Button className="p-[5px_15px] border-green-600 hover:border-green-600 hover:text-green-600 hover:bg-white bg-green-600 text mb-4 rounded-sm text-white">
          <Link
            to={"/admin/createQuestion"}
            className="hover:text-white flex items-center"
          >
            <PlusCircleOutlined className="mr-1" />
            Thêm mới
          </Link>
        </Button>
      </div>
      <Title className='mt-[20px]' level={3}>Danh sách câu hỏi khảo sát</Title>
      <Table
        dataSource={questions}
        pagination={{
          locale: { items_per_page: "bản ghi / Trang" },
          current: currentPage,
          defaultPageSize: 10,
          onChange: handlePageChange,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50"],
          onShowSizeChange(current, size) {
            setPageSize(size)
          },
          showTotal: (total: any, range: any) =>
            `${range[0]}-${range[1]} Tổng ${total} bản ghi`,
        }}
        columns={columns}
        rowKey={(record: any) => record.id}
        className="mt-[15px]"
        locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_DEFAULT} description="Không có dữ liệu!" /> }}
      />
    </div>
  );
};

export default ListQuestion;
